/**
 * The Ask button on every screen (the shell). The sheet it opens (components/Ask.tsx: the answers, the guides, the catalogs behind
 * them) loads on the first tap, so the first file carries none of it.
 */
import { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { lazyNamed } from "../lib/lazy.ts";
import { Icon } from "./Icons.tsx";

const AskSheet = lazyNamed(() => import("./Ask.tsx"), "AskSheet");

export function AskButton() {
  const [open, setOpen] = useState(false);
  // A link may open it (?ask=1: the demo tour's Ask screen), once per visit to that link.
  const loc = useLocation();
  useEffect(() => { if (new URLSearchParams(loc.search).get("ask") === "1") setOpen(true); }, [loc.key, loc.search]);
  return (
    <>
      <button type="button" className="ask-fab" onClick={() => setOpen(true)} aria-haspopup="dialog" aria-label="Ask CleanCleaver"><Icon name="spark" size={20} /><span className="ask-long">Ask CleanCleaver</span><span className="ask-short" aria-hidden="true">Ask</span></button>
      {open && <Suspense fallback={null}><AskSheet onClose={() => setOpen(false)} /></Suspense>}
    </>
  );
}
